import { parseISO } from 'date-fns';
import type { ProgramMemberDataObject } from '../service';
import { type UserList, createUserList } from '../user';

export type ProgramMember = {
  invitedAt?: Date;
  joined: boolean;
  joinedAt?: Date;
} & UserList;

export const createProgramMember = (data: ProgramMemberDataObject): ProgramMember => ({
  ...createUserList(data),
  invitedAt: data.invited_at ? parseISO(data.invited_at) : undefined,
  joined: data.joined,
  joinedAt: data.joined_at ? parseISO(data.joined_at) : undefined,
});
